export default __webpack_public_path__ + "static/media/AceiteDeCoco.22927ff1.jpeg";